<div class="promotion-popup-modal" [class.promotion-popup-modal--no-image]="!hasPromotionImage()">
  @if (hasPromotionImage()) {
    <div class="modal-content modal-content--with-image" (click)="onModalClick()">
      <button
        class="close-button"
        type="button"
        (click)="onCloseClick($event)"
        mat-icon-button
        aria-label="Cerrar modal de promoción">
        <mat-icon>close</mat-icon>
      </button>

      <div
        class="promotion-background-image"
        [style.background-image]="'url(' + getPromotionImageUrl() + ')'"
        role="img"
        [attr.aria-label]="data.promotion.title">
      </div>

      @if (data.promotion.subtitle) {
        <div class="promotion-description-banner">
          <p class="promotion-description-text">
            {{ data.promotion.subtitle }}
          </p>
        </div>
      }
    </div>
  } @else {
    <div class="modal-content modal-content--no-image">
      <button
        class="close-button"
        type="button"
        (click)="onCloseClick()"
        mat-icon-button
        aria-label="Cerrar modal de promoción">
        <mat-icon>close</mat-icon>
      </button>

      <div class="promotion-text">
        <h2 class="promotion-title">
          {{ data.promotion.title }}
        </h2>

        @if (data.promotion.subtitle) {
          <p class="promotion-subtitle">
            {{ data.promotion.subtitle }}
          </p>
        }

        <div class="promotion-actions">
          <button
            class="cta-button"
            type="button"
            (click)="onButtonClick()">
            {{ getButtonText() }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
